// main-view.js

import $ from 'jquery';
import _ from 'lodash';

import { View } from 'backbone';
import propertyViewMapService from 'PropertyViewMapService.js';

import contentTemplate from 'properties/main-view.ejs';

class MainView extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.tagName = 'div';
        this.id = '#propMain';
        //this.className = 'propMain';
        this.factoryKey = opts.factoryKey;

        this.template = contentTemplate;
        //this.listenTo(this.model, 'change', this.render);

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        return this;
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        // Render Property Views
        const views = propertyViewMapService.getMainViews(this.factoryKey);
        if (views) {
            views.map( v => {
                var obj = new v.view({model: this.model, el: $(v.el) });
                obj.render();
            });
        }

        return this;
    }
}

export default MainView;